import { render, staticRenderFns } from "./WalletSvg.vue?vue&type=template&id=7978fc48&scoped=true&"
import script from "./WalletSvg.vue?vue&type=script&lang=js&"
export * from "./WalletSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7978fc48",
  null
  
)

export default component.exports